module.exports = __webpack_public_path__ + "04_bob_beige.f77479b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_bob_beige.png
// module id = WKOJ
// module chunks = 0